module.exports = __webpack_public_path__ + "media/images/icons/fa-sitemap-057373fd7f2775f74af598501fb0f05d.svg";